/**
 * Common validation utilities for CrossFrame listeners.
 */

/**
 * Validates that all specified string fields are present and non-empty in the data object.
 * Throws an Error with the field name if any is missing.
 */
export function validateRequired (data: Record<string, any>, ...fields: string[]): void {
    for (const field of fields) {
        if (!data[field]) {
            throw new Error(`${field} is required`)
        }
    }
}

/**
 * Validates that a numeric field is present (not undefined/null) in the data object.
 * Unlike validateRequired, this correctly handles 0 as a valid value.
 */
export function validateRequiredNumeric (data: Record<string, any>, ...fields: string[]): void {
    for (const field of fields) {
        if (data[field] === undefined || data[field] === null) {
            throw new Error(`${field} is required`)
        }
    }
}

/**
 * Validates that an array field is present and non-empty in the data object.
 */
export function validateRequiredArray (data: Record<string, any>, ...fields: string[]): void {
    for (const field of fields) {
        if (!data[field] || data[field].length === 0) {
            throw new Error(`${field} is required`)
        }
    }
}
